var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { createPortal } from "react-dom";
import { bind } from "decko";
import { utilEnableScrollLock, utilDisableScrollLock } from "./util/util";
import { css, keyframes, cx } from "emotion";
const animation = keyframes `
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const overlayClass = css({
    animation: `${animation} .5s`,
    backgroundColor: "rgba(0,0,0, .1)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    overflow: "auto",
    top: 0,
    right: 0,
    left: 0,
    zIndex: 9999100,
});
const overlayContentClass = css({
    zIndex: 9999999,
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    "> *": {
        pointerEvents: "initial",
    },
});
const outsideClickAreaClass = css({
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 9999110,
});
class PortalHolder extends React.Component {
    componentDidMount() {
        utilEnableScrollLock();
    }
    componentWillUnmount() {
        utilDisableScrollLock(false);
    }
    handleClickOutside(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onClickOutside && this.props.onClickOutside(event);
    }
    render() {
        const style = {};
        if (this.props.coverAllTheThings) {
            style.zIndex = 2147483647;
        }
        return (React.createElement("div", { className: cx(overlayClass), style: style, tabIndex: -1 },
            React.createElement("div", { className: cx(overlayContentClass) }, this.props.children),
            React.createElement("div", { className: cx(outsideClickAreaClass), onClick: this.handleClickOutside })));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PortalHolder.prototype, "handleClickOutside", null);
export class Portal extends React.Component {
    constructor() {
        super(...arguments);
        this.portalNode = null;
    }
    componentWillUnmount() {
        if (this.portalNode) {
            document.body.removeChild(this.portalNode);
        }
        this.portalNode = null;
    }
    render() {
        if (!this.portalNode) {
            this.portalNode = document.createElement("div");
            document.body.appendChild(this.portalNode);
        }
        return createPortal(React.createElement(PortalHolder, Object.assign({}, this.props)), this.portalNode);
    }
}
export default Portal;
//# sourceMappingURL=portal.js.map